import React, { useState } from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { proposalConfirm } from '@services/proposals';
import { StatusConfirmType } from '@interface/proposals';
import useAmplitude from '@hooks/useAmplitude';
import { ActionsPropsInterface } from './ActionsTypes';

function Actions({
  actions,
  proposalId,
  isReject,
  onClose,
  onRejected,
}: ActionsPropsInterface) {
  const [isLoading, setIsLoading] = useState(false);
  const { amplitudeEvent } = useAmplitude();
  const flow = isReject ? 'reject' : 'confirm';
  const nameEvent = `modal_proposal_${flow}_action_click`;

  function handleRejected() {
    amplitudeEvent(`${nameEvent}_cancel`, {
      source: `button-${actions.rejected.text.toLowerCase().replace(' ', '-')}`,
    });

    onRejected();
  }

  function handleConfirm() {
    let status: StatusConfirmType = 'accepted';

    if (isLoading) {
      return;
    }

    amplitudeEvent(`${nameEvent}_confirm`, {
      source: `button-${actions.confirm.text.toLowerCase().replace(' ', '-')}`,
    });

    if (isReject) {
      status = 'refused';
    }

    setIsLoading(true);

    proposalConfirm(proposalId, status)
      .then((response) => {
        window.dispatchEvent(
          new CustomEvent('proposalConfirmedSuccess', {
            detail: {
              proposalId: response.proposal.id,
              freightId: response.proposal.freight.id,
              journeyId: response.proposal.journey.id,
              journeyCode: response.proposal.journey.code,
              message: response.message,
              isReject,
            },
          }),
        );
      })
      .catch((error) => {
        window.dispatchEvent(
          new CustomEvent('proposalConfirmedError', {
            detail: {
              proposalId,
              isReject,
              message: {
                title: 'Não foi possível realizar esta ação',
                description: 'Tente novamente mais tarde',
              },
              status: error?.status,
            },
          }),
        );
      })
      .finally(() => {
        setIsLoading(false);
        onClose();
      });
  }

  return (
    <FuelFlex
      defaultProps={{
        customMargin: '12px 0 0 0 ',
        gap: 'km2',
        justifyContent: 'flex-end',
      }}
    >
      <FuelButton
        onClick={() => handleRejected()}
        variant="tertiary"
        size="large"
      >
        {actions.rejected.text}
      </FuelButton>
      <FuelButton
        size="large"
        isLoading={isLoading}
        onClick={() => handleConfirm()}
      >
        {actions.confirm.text}
      </FuelButton>
    </FuelFlex>
  );
}

export default Actions;
